import React from 'react';
import { useLocalization, useTranslate } from '@im/react-localization';
import { Button, ButtonProps } from '@im/ui-lib/zenith/Button';
import { styled } from '@mui/material/styles';
import { Icon } from '@im/ui-lib/zenith/Icon';
import Typography from '@mui/material/Typography';

// eslint-disable-next-line import/no-unassigned-import
import type {} from '@im/im-theme/themeAugmentation';

export const ErrorContentWithThemeX4EC = ({
  actionButtonProps,
  errorMessage,
  hideActionButton = false,
}: {
  actionButtonProps?: ButtonProps;
  errorMessage?: string | React.ReactNode;
  hideActionButton?: boolean;
}) => {
  const { translate } = useLocalization();
  const translateStr = useTranslate();

  return (
    <Root id="error-boundary-th-x4ec">
      <img
        alt={translateStr('Common.Somethingwentwrong')}
        src="/xshared/assets/img/errorBoundary.svg"
        style={{ marginBottom: '50px' }}
      />

      <Typography variant="text-sm-regular">
        {errorMessage
          ? errorMessage
          : translate('ErrorBoundary.ErrorText', undefined, true)}
      </Typography>

      <Typography
        sx={{
          mb: 8,
          mt: 8,
        }}
        variant="text-xl-regular"
      >
        {translate('Common.PageErrorMainText')}
      </Typography>
      {!hideActionButton && (
        <Button
          href="/x4ec/app/home"
          startIcon={<Icon iconId="ArrowLeft" />}
          variant="primary"
          {...actionButtonProps}
        >
          {actionButtonProps?.children || translate('Common.BackToHome')}
        </Button>
      )}
    </Root>
  );
};
const Root = styled('div')(() => ({
  margin: '50px auto 0px',
  maxWidth: '1500px',
  textAlign: 'center',
}));
